// The voucher list and confirmed cart can return different casing for one code.
// Compare identity without rewriting the customer's request or backend payload.
const sameVoucherCode = (left, right) =>
  typeof left === 'string' &&
  typeof right === 'string' &&
  left.length > 0 &&
  left.toLowerCase() === right.toLowerCase()

export default sameVoucherCode
